<template>
	<LayoutScreen background="--background-base" max-width="500px" content-align="center">
		<template #content>
			<LayoutFlex padding="var(--size-24) var(--size-20)" gap="var(--size-24)" align-items="center">
				<!-- 64px badge = 24px icon + 20px padding (Figma node 30633-7517). -->
				<LayoutFlex
					padding="var(--size-20)"
					gap="0"
					background="--background-brand-high"
					corner-radius="var(--size-24)"
					aria-hidden="true"
				>
					<Icon type="ds_check" size="--size-24" color="--text-white-primary" />
				</LayoutFlex>
				<LayoutFlex padding="0" gap="var(--size-12)" align-items="center">
					<Text font="--heading-h3" color="--text-dark-primary" text-align="center">Payment method updated</Text>
					<Text font="--text-16-22-reg" color="--text-dark-secondary" text-align="center">
						To verify your new payment method, we placed a temporary $1 charge on your card. It will be automatically
						refunded.
					</Text>
				</LayoutFlex>
			</LayoutFlex>
		</template>

		<template #footer>
			<LayoutFlex padding="0 var(--size-20) var(--size-24)" gap="0">
				<Button full-width @ds:click="onDone">
					<Text font="--text-16-18-semi">Done</Text>
				</Button>
			</LayoutFlex>
		</template>
	</LayoutScreen>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { Button, Icon, LayoutFlex, LayoutScreen, Text } from '@simple-life-app/growth-ui-kova'
import { trackUpdatePaymentScreenView, trackUpdatePaymentSuccessDoneClick } from '@/analytics/events'
import { flushBeforeLeaving } from '@/analytics/client'
import { openDeeplink } from '@/deeplinks'
import { useLocationStore } from '@/store/location'

const router = useRouter()
// Named locationStore (not location) to avoid shadowing window.location in a view file.
const locationStore = useLocationStore()

onMounted(() => {
	trackUpdatePaymentScreenView('UPDATE_PAYMENT_METHOD_SUCCESS_SCREEN')
})

async function onDone() {
	trackUpdatePaymentSuccessDoneClick()
	if (locationStore.isWebview) {
		// The app may close the webview the moment it receives the deeplink — flush the click
		// event first (bounded, best-effort), same reason SignIn.vue flushes before the Auth0
		// redirect. The deeplink must fire regardless — hence the finally.
		try {
			await flushBeforeLeaving()
		} finally {
			openDeeplink('paymentDone')
		}
	} else {
		router.push('/status')
	}
}
</script>
